var _style, _polyline, _line, _line2, _ellipse, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuglarSecurityAlarm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3,4.1 3,2.3 4.3,2.3 4.3,11.4 6,11.4 6,2.3 7.7,2.3 7.7,11.4 9.3,11.4 9.3,2.3 11.1,2.3 11.1,11.4  13,11.4 13,8.1 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.6,
    y1: 13.8,
    x2: 8.6,
    y2: 14.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.6,
    y1: 14.4,
    x2: 8.6,
    y2: 14.9
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 8,
    cy: 14.4,
    rx: 0.6,
    ry: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 0.5,
    className: "st0",
    width: 13.1,
    height: 12.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 13.2,
    className: "st0",
    width: 13.1,
    height: 2.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuglarSecurityAlarm);
export default __webpack_public_path__ + "static/media/BuglarSecurityAlarm.4c806e13d00a4afd5d0da0ff5238930b.svg";
export { ForwardRef as ReactComponent };